import React, { useEffect, useState } from 'react'
import Layout from '../../dashboard/components/Layout'
import Card from '../../../components/Card'
import DataGrid from 'react-data-grid'
import '../../dashboard/managerdashboard/pages/index.css'
import CustomPagination from '../../../components/Pagination'
import { Search } from '../../../components'
import { useAppDispatch, useAppSelector } from '../../../redux/hook'
import { Announcements, PersonalTimeOff } from '../../dashboard/types'
import {
    announcementList,
    markAnnouncement,
    personalTimeOff,
} from '../../dashboard/api'
import { HIDE_LOADER, SHOW_LOADER } from '../../../redux/slices/LoaderSlice'
import { annDateFormat, formatDate } from '../../dashboard/utils'
import { SHOW_NOTIFICATION } from '../../../redux/slices/showNotificationSlice'
import { AssignProgram } from '../../resources/empresources/type'
import { getAssignedPrograms } from '../../resources/empresources/api'
import { Icon } from '@iconify/react'
import { truncateString } from '../../../utils'
const TeacherDashboard: React.FC = () => {
    const dispatch = useAppDispatch()
    const { id } = useAppSelector((state) => state.persistedReducers.user)
    const { show } = useAppSelector((state) => state.loader)
    const [perosnaltimeOff, setPerosnalTimeOff] = useState<PersonalTimeOff[]>(
        []
    )
    const [programassignlist, setProgramAssignList] = useState<AssignProgram[]>(
        []
    )
    const [programtotalCount, setProgramTotalCount] = useState<number>(0)
    const [currentPage, setCurrentPage] = useState<number>(1)
    const [totalCount, setTotalCount] = useState<number>(0)
    const totalPages = Math.ceil(totalCount / 3)
    const [announcementsList, setAnnouncemnetsList] = useState<Announcements[]>(
        []
    )
    const [search, setSearch] = useState<string>('')
    const programtotalPages = Math.ceil(programtotalCount / 3)
    const [programcurrentPage, setProgramCurrentPage] = useState<number>(1)

    useEffect(() => {
        dispatch(SHOW_LOADER())
        const gettimeOff = async () => {
            try {
                const response = await personalTimeOff(3, currentPage, id)
                setPerosnalTimeOff(response?.data?.data)
                setTotalCount(response?.data?.totalCount)
                dispatch(HIDE_LOADER())
            } catch (err) {
                // Handle any errors here
                console.error('Error fetching:', err)
                dispatch(HIDE_LOADER())
            }
        }

        gettimeOff()
    }, [currentPage])

    const getannouncements = async () => {
        try {
            const response = await announcementList(100, 1, search)
            if (response?.data?.data?.length !== 0) {
                // sort by last modified date and time in typeScript
                response.data.data.sort((a: any, b: any) => {
                    return (
                        new Date(b.lastModifiedOn).getTime() -
                        new Date(a.lastModifiedOn).getTime()
                    )
                })
            }
            setAnnouncemnetsList(response?.data?.data)
            dispatch(HIDE_LOADER())
        } catch (err) {
            // Handle any errors here
            console.error('Error fetching:', err)
            dispatch(HIDE_LOADER())
        }
    }

    useEffect(() => {
        getannouncements()
    }, [search])

    const getValue = (value: string) => {
        setSearch(value)
    }

    const completeMark = async (id: string) => {
        dispatch(SHOW_LOADER())
        try {
            const response = await markAnnouncement(id)
            if (response.status === 200) {
                dispatch(HIDE_LOADER())
                getannouncements()
                dispatch(
                    SHOW_NOTIFICATION({
                        type: 'success',
                        message: 'Read successfully',
                    })
                )
            }
        } catch (err) {
            dispatch(HIDE_LOADER())
            console.log('Error fetching', err)
        }
    }

    useEffect(() => {
        dispatch(SHOW_LOADER())
        const fetchData = async () => {
            try {
                // Call the asynchronous function and wait for its result
                const programData = await getAssignedPrograms({
                    currentPage: programcurrentPage,
                    recordsPerPage: 3,
                })
                setProgramAssignList(programData?.data?.data)
                setProgramTotalCount(programData?.data?.totalCount)

                // Dispatch the action with the data if needed

                dispatch(HIDE_LOADER())
            } catch (err) {
                dispatch(HIDE_LOADER())
                // Handle any errors here
                console.error('Error fetching :', err)
            }
        }

        // Call the function to fetch data
        fetchData()
    }, [programcurrentPage])

    const column = [
        {
            key: 'leaveType',
            name: `Type`,
            resizable: true,
            sortable: true,
        },
        {
            key: 'status',
            name: `Status`,
            resizable: true,
            renderCell: (props: any) => {
                return (
                    <div
                        className={
                            props.row.status === 'Pending'
                                ? 'status'
                                : props.row.status === 'Approved'
                                  ? 'appr'
                                  : 'rej'
                        }
                    >
                        {props.row.status}
                    </div>
                )
            },
            sortable: true,
        },
        {
            key: 'date',
            name: `Dates`,
            resizable: true,
            sortable: true,
            renderCell: (props: any) => {
                return (
                    <div className="">
                        {formatDate(props.row.startDate)} -{' '}
                        {formatDate(props.row.endDate)}
                    </div>
                )
            },
        },
    ]

    const column1 = [
        {
            key: 'folderName',
            name: `Title`,
            resizable: true,
            sortable: true,
            minWidth: 350,
        },
        {
            key: 'status',
            name: `Status`,
            resizable: true,
            sortable: true,
            minWidth: 200,
            renderCell: (props: any) => {
                return (
                    <div
                        className={
                            props.row.status === 'Pending'
                                ? 'status'
                                : props.row.status === 'Completed'
                                  ? 'appr'
                                  : 'rej'
                        }
                    >
                        {props.row.status}
                    </div>
                )
            },
        },
    ]

    const getCurrentPage = (page: number, peronsnal: boolean) => {
        peronsnal ? setCurrentPage(page) : setProgramCurrentPage(page)
    }

    return (
        <div>
            <Layout>
                <div className="row">
                    <div className="col-sm-8">
                        <div className="row">
                            <div className="col-md-12">
                                <Card>
                                    <h6>
                                        <p>Personal Upcoming Time Off</p>
                                    </h6>
                                    {!show &&
                                    perosnaltimeOff &&
                                    perosnaltimeOff?.length > 0 ? (
                                        <DataGrid
                                            className="data-grid-table custom"
                                            columns={column}
                                            rows={perosnaltimeOff}
                                            rowHeight={60}
                                            headerRowHeight={40}
                                        />
                                    ) : (
                                        <>
                                            <div className="no-records">
                                                You don’t have any upcoming Paid
                                                Time Off.
                                            </div>
                                        </>
                                    )}
                                    {perosnaltimeOff?.length > 0 && (
                                        <CustomPagination
                                            totalPages={totalPages}
                                            currentPage={currentPage}
                                            getPageNumber={(page: number) =>
                                                getCurrentPage(page, true)
                                            }
                                        />
                                    )}
                                </Card>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <Card>
                                    <div>
                                        <h6>Assigned Training Programs</h6>
                                    </div>

                                    {programassignlist?.length === 0 ? (
                                        <div className="no-records">
                                            No Assigned Programs
                                        </div>
                                    ) : (
                                        <DataGrid
                                            className="data-grid-table custom"
                                            columns={column1}
                                            rows={programassignlist}
                                            rowHeight={60}
                                            headerRowHeight={40}
                                        />
                                    )}

                                    {programassignlist?.length > 0 && (
                                        <CustomPagination
                                            totalPages={programtotalPages}
                                            currentPage={programcurrentPage}
                                            getPageNumber={(page: number) =>
                                                getCurrentPage(page, false)
                                            }
                                        />
                                    )}
                                </Card>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4 dashboard-announcements">
                        <Card>
                            <div className="announcement-block">
                                <h6>Announcements</h6>
                            </div>
                            <div>
                                <Search
                                    placeholder="Search Announcement"
                                    onSearch={getValue}
                                />
                            </div>

                            {announcementsList?.length === 0 ? (
                                <div className="no-announcements">
                                    No Announcements yet.
                                </div>
                            ) : (
                                announcementsList.map(
                                    (announcements: Announcements) => {
                                        return (
                                            <div
                                                className="announcemt-section"
                                                key={`ann-${announcements.id}`}
                                            >
                                                <label>
                                                    {
                                                        announcements.announcementTitle
                                                    }
                                                </label>

                                                <p className="mt-1">
                                                    {
                                                        announcements.announcementDescription
                                                    }
                                                </p>
                                                {announcements.link && (
                                                    <div className="mb-1">
                                                        <span>
                                                            {truncateString(
                                                                announcements.link
                                                            )}
                                                        </span>
                                                        <Icon
                                                            icon="ion:open-outline"
                                                            color="#39877C"
                                                            style={{
                                                                cursor: 'pointer',
                                                                marginLeft:
                                                                    '5px',
                                                            }}
                                                            onClick={() => {
                                                                const url =
                                                                    announcements.link.startsWith(
                                                                        'http://'
                                                                    ) ||
                                                                    announcements.link.startsWith(
                                                                        'https://'
                                                                    )
                                                                        ? announcements.link
                                                                        : `http://${announcements.link}`
                                                                window.open(
                                                                    url,
                                                                    '_blank'
                                                                )
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                                <div className="title">
                                                    <h5>
                                                        {annDateFormat(
                                                            announcements.lastModifiedOn
                                                        )}
                                                    </h5>
                                                    <h6
                                                        onClick={() =>
                                                            completeMark(
                                                                announcements.id
                                                            )
                                                        }
                                                    >
                                                        {'Mark as read'}
                                                    </h6>
                                                </div>
                                            </div>
                                        )
                                    }
                                )
                            )}
                        </Card>
                    </div>
                </div>
            </Layout>
        </div>
    )
}

export default TeacherDashboard
